export const headingStyle = {
    color: '#FF9906',
    fontWeight: 700,
    mb: 3,
    textAlign: 'center',
    fontSize: {
        xs: '24px',
        sm: '28px',
        md: '30px',
    },
};

export const textStyle = {
    mb: 5,
    fontWeight: 700,
    textAlign: 'center',
    fontSize: {
        xs: '24px',
        sm: '28px',
        md: '30px',
    },
};


